import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

import FormModule from "@/core/base/FormModule";

@Module({ namespaced: true })
export default class TopSellingReport extends FormModule {
  override endPoint = "TopSellingReport";
}
